export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20with%20deep%20crimson%20and%20dark%20shadow%20gradients%2C%20mysterious%20atmosphere%2C%20flowing%20dark%20waves%20with%20warm%20golden%20accents%2C%20cinematic%20mood%2C%20modern%20digital%20art%2C%20entertainment%20portal%20aesthetic&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="吃瓜入口主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-20">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-4 md:mb-5">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-xs md:text-sm font-medium whitespace-nowrap">
                全网黑料吃瓜第一入口
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-3 md:mb-4">
              吃瓜入口 · 每日黑料独家聚合平台
            </h1>

            <p className="text-accent-300 text-base md:text-lg font-heading mb-5 md:mb-6">
              51黑料吃瓜入口 &amp; 黑料吃瓜在线 · 全网最全吃瓜聚集地
            </p>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-5 md:mb-6">
              聚焦黑料吃瓜入口与黑料吃瓜在线等热门渠道，每日精选娱乐圈、财经圈、网红圈最新独家爆料。
              支持黑料视频在线看，覆盖51黑料吃瓜入口、51在线吃瓜今日吃瓜入口等全部热门入口，
              打造一站式吃瓜体验。当前站内热门话题涵盖明星塌房、品牌解约、网红互撕等多条线索，
              每日更新量超百条，确保你不错过任何精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="text-center">
                <div className="text-accent-400 text-xl md:text-2xl font-heading">日均200+</div>
                <div className="text-white/50 text-xs mt-1 whitespace-nowrap">内容更新</div>
              </div>
              <div className="w-px h-8 bg-white/20"></div>
              <div className="text-center">
                <div className="text-accent-400 text-xl md:text-2xl font-heading">7×24h</div>
                <div className="text-white/50 text-xs mt-1 whitespace-nowrap">不间断运营</div>
              </div>
              <div className="w-px h-8 bg-white/20"></div>
              <div className="text-center">
                <div className="text-accent-400 text-xl md:text-2xl font-heading">多节点</div>
                <div className="text-white/50 text-xs mt-1 whitespace-nowrap">稳定访问</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap text-sm"
              >
                立即吃瓜
              </a>
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg border border-white/30 transition-colors text-center cursor-pointer whitespace-nowrap text-sm"
              >
                观看视频
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20theatrical%20composition%20with%20deep%20crimson%20curtains%20and%20warm%20golden%20spotlight%2C%20mysterious%20stage%20setting%2C%20entertainment%20news%20portal%20visual%2C%20cinematic%20quality%2C%20rich%20dark%20textures%2C%20professional%20photography%20style&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="吃瓜入口 - 黑料吃瓜入口主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded whitespace-nowrap">实时</span>
                  <span className="text-white/90 text-xs">每日黑料独家更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}